import { useLayoutEffect } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const NO_SCROLL_CLASSNAME = 'hs-nav-no-scroll';
const StyledDiv = styled.div.withConfig({
  displayName: "Modal__StyledDiv",
  componentId: "sc-1fqjn0l-0"
})(["background-color:rgba(45,62,80,0.79);bottom:0;contain:content;left:0;overflow:auto;position:fixed;right:0;top:0;z-index:9999;width:100vw;height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;backdrop-filter:blur(5px);"]);
const Modal = ({
  children
}) => {
  useLayoutEffect(() => {
    document.body.classList.add(NO_SCROLL_CLASSNAME);
    return () => {
      document.body.classList.remove(NO_SCROLL_CLASSNAME);
    };
  }, []);
  return /*#__PURE__*/_jsx(StyledDiv, {
    role: "presentation",
    tabIndex: -1,
    children: /*#__PURE__*/_jsx("div", {
      role: "dialog",
      "aria-modal": "true",
      children: children
    })
  });
};
export default Modal;